export const GIZLILIK_TEXT = `FIVE STAR GİZLİLİK POLİTİKASI
Son güncelleme: 16 Eylül 2026
Five Star olarak gizliliğine önem veriyoruz. Bu Gizlilik Politikası, Five Star mobil uygulamasını ve meetfivestar.app internet sitesini kullandığında kişisel bilgilerinin nasıl toplandığını, kullanıldığını, saklandığını ve korunduğunu açıklar.
Bu politika, Five Star’ın sunduğu üyelik, eşleştirme, mesajlaşma, randevulaşma, geri bildirim ve bağlantılı hizmetler için geçerlidir.
1. Topladığımız bilgiler
Five Star’ı kullandığında aşağıdaki bilgileri toplayabiliriz:
Hesap ve profil bilgileri
• ad
• soyad
• doğum tarihi
• yaş
• cinsiyet
• e-posta adresi
• profil fotoğrafları
• profil bilgileri ve başvuru cevapları
Instagram kullanıcı adı
Başvuru sırasında verdiğin Instagram kullanıcı adı yalnızca başvurunun doğrulanması ve değerlendirilmesi amacıyla Five Star’ın yetkili ekibi tarafından görüntülenir.
Instagram kullanıcı adın diğer üyelere gösterilmez.
Tercih ve eşleştirme bilgileri
Five Star içerisindeki seçimlerin, sana sunulan profiller, eşleşmeler, My Date durumları ve diğer uygulama içi etkileşimlerin işlenebilir.
Bu bilgiler sana daha uygun profiller sunmak ve eşleştirme sistemini geliştirmek amacıyla kullanılabilir.
Mesajlaşma ve iletişim verileri
Five Star üzerinden diğer üyelerle gerçekleştirdiğin uygulama içi yazışmalar ve Çöpçatan mesajları; mesaj içeriği, gönderen/alıcı bilgisi, gönderim zamanı ve okunma durumuna ilişkin sınırlı teknik bilgilerle birlikte sistemlerimizde saklanabilir.
Randevu bilgileri
Uygulama üzerinden bir buluşma planladığında tarih, saat, konum/metin bilgisi ve randevunun durumu gibi bilgiler kaydedilebilir.
Geri bildirimler
Eşleşme veya buluşma sonrasında Five Star’a verdiğin geri bildirimler, gelecekteki eşleşmelerini geliştirmek ve Platformun güvenliğini artırmak amacıyla kullanılabilir.
Özel geri bildirimler diğer kullanıcıya otomatik olarak gösterilmez.
2. Bilgilerini neden kullanıyoruz?
Bilgilerini özellikle şu amaçlarla kullanabiliriz:
• hesabını oluşturmak ve yönetmek,
• üyelik başvurunu değerlendirmek,
• profilini oluşturmak,
• sana Five Star eşleştirmelerini sunmak,
• belirli dönemlerde beş profil seçmek,
• eşleştirme kalitesini geliştirmek,
• kullanıcılar arasında mesajlaşmayı sağlamak,
• My Date özelliklerini işletmek,
• randevu oluşturmanı sağlamak,
• geri bildirimleri değerlendirmek,
• güvenlik sorunlarını araştırmak,
• sahte ve kötüye kullanım amaçlı hesapları azaltmak,
• kullanıcı desteği sağlamak,
• abonelik durumunu doğrulamak,
• uygulamanın performansını ve güvenliğini geliştirmek,
• yasal yükümlülüklerimizi yerine getirmek.
3. Kürasyon ve iç eşleştirme sinyalleri
Five Star, sana uygun profilleri seçebilmek amacıyla Platform içerisindeki tercihlerini ve etkileşimlerini değerlendirebilir.
Bu süreçte bazı iç değerlendirme ve eşleştirme sinyalleri oluşturulabilir.
Bu tür bilgiler Five Star’ın iç eşleştirme sisteminde ve yetkili yönetim araçlarında kullanılabilir ve diğer üyelere gösterilmez.
4. Üyelik ve ödeme bilgileri
Five Star üyelik hizmetleri ücretli olarak sunulabilir.
Uygulama içi üyelik ödemeleri, kullanıcının cihazına ve kullandığı platforma bağlı olarak Apple App Store veya Google Play üzerinden gerçekleştirilebilir.
Five Star, kullanıcıların kredi kartı veya banka kartı numaralarını doğrudan toplamaz veya saklamaz.
Ödeme işlemleri ilgili uygulama mağazasının ödeme altyapısı üzerinden yürütülür.
Five Star, üyeliğin etkinleştirilmesi, aboneliğin doğrulanması ve hizmetin sunulması amacıyla satın alma ve abonelik durumuna ilişkin sınırlı işlem bilgilerini işleyebilir.
Apple App Store veya Google Play tarafından doğrudan işlenen kişisel veriler, ilgili platformun kendi gizlilik politikaları kapsamında değerlendirilir.
5. Bilgilerini kimlerle paylaşabiliriz?
Kişisel bilgilerini satmayız.
Bilgilerin yalnızca hizmetin çalışması için gerekli olduğu ölçüde aşağıdaki taraflarla paylaşılabilir:
• uygulamanın teknik altyapısını sağlayan hizmet sağlayıcılar,
• veritabanı ve barındırma sağlayıcıları,
• kimlik doğrulama hizmetleri,
• ödeme ve uygulama mağazası sağlayıcıları,
• teknik hata ve güvenlik hizmetleri,
• hukuken yetkili kamu kurumları.
Üçüncü taraf hizmet sağlayıcılar yalnızca hizmetlerinin gerektirdiği kapsamda verilere erişebilir.
6. Diğer kullanıcılara gösterilen bilgiler
Five Star profilinde yer alan bazı bilgiler, eşleşme sürecinin parçası olarak diğer üyelere gösterilebilir.
Bunlar örneğin:
• ad veya uygulamada kullanılan profil adı,
• yaş,
• profil fotoğrafları,
• kullanıcı profilinde gösterilmesi amaçlanan diğer bilgiler
olabilir.
Ancak aşağıdaki bilgiler diğer kullanıcılara gösterilmez:
• Instagram kullanıcı adın,
• başvuru değerlendirmesine özel bilgiler,
• Five Star’a verdiğin özel geri bildirimler,
• yönetim sisteminde tutulan iç değerlendirme ve eşleştirme sinyalleri,
• özel destek veya gizlilik yazışmaların.
7. Mesajlaşma gizliliği
Üyeler arasındaki mesajlar herkese açık değildir ve yalnızca ilgili konuşmanın katılımcıları tarafından uygulama üzerinden görüntülenebilir.
Five Star ekibi olağan hizmet akışında üyeler arasındaki özel yazışmaları görüntülemez; ancak hizmetin teknik olarak yürütülmesi, güvenlik, kötüye kullanım veya şikâyet incelemeleri ve hukuki yükümlülükler kapsamında yetkili erişim mümkün olabilir.
Çöpçatan tarafından kullanıcıya gönderilen mesajlar ise hizmetin yürütülmesi kapsamında yetkili Five Star ekibi tarafından görüntülenebilir.
8. Gerçek hayattaki buluşmalar
Five Star kullanıcıların tanışmasını kolaylaştıran bir platformdur.
Uygulama üzerinden yapılan bir eşleşme veya profil önerisi, ilgili kullanıcının kimliği, davranışları, güvenilirliği veya gerçek hayattaki güvenliği konusunda garanti anlamına gelmez.
Kullanıcıların gerçek hayattaki buluşmalarında kişisel güvenliklerini gözetmeleri gerekir.
Şüpheli veya uygunsuz davranışları support@meetfivestar.app adresinden bildirebilirsin.
9. Verilerini ne kadar süre saklıyoruz?
Kişisel bilgilerini, hizmetin sunulması için gerekli olduğu süre boyunca ve yasal yükümlülüklerimizin gerektirdiği sürelerde saklarız.
Hesabını silmen halinde bilgilerinin silinmesi veya anonimleştirilmesi için gerekli süreç başlatılır.
Ancak dolandırıcılık önleme, hukuki uyuşmazlıklar, güvenlik kayıtları veya mevzuat gereği saklanması zorunlu bazı bilgiler belirli sürelerle tutulabilir.
10. Hesabını ve verilerini silme
Hesabını uygulama içerisindeki:
Ayarlar → Yasal & Gizlilik → Hesabımı Sil
alanından silebilirsin veya silme talebi oluşturabilirsin.
Kişisel verilerine erişmek, düzeltilmesini istemek veya gizlilik kapsamında başka bir talepte bulunmak için:
privacy@meetfivestar.app
adresinden bize ulaşabilirsin.
11. Veri güvenliği
Five Star, kişisel bilgilerin yetkisiz erişime, kayba, kötüye kullanıma veya değiştirmeye karşı korunması amacıyla uygun teknik ve idari önlemler kullanır.
Bununla birlikte internet üzerinden çalışan hiçbir hizmetin tamamen risksiz olduğu garanti edilemez.
Hesap bilgilerini ve giriş bilgilerini başka kişilerle paylaşmamanı öneririz.
12. Çocukların gizliliği
Five Star yalnızca 18 yaş ve üzerindeki kişiler tarafından kullanılabilir.
18 yaşından küçük kişilerin Five Star’da hesap oluşturmasına izin verilmez.
18 yaşından küçük bir kişiye ait bilgilerin Platformda bulunduğunu fark edersek gerekli işlemleri gerçekleştiririz.
13. Yurt dışına veri aktarımı
Five Star’ın kullandığı bazı teknik hizmet sağlayıcıların sistemleri Türkiye dışında bulunabilir.
Bu nedenle kişisel verilerin, ilgili hukuki şartların sağlanması halinde yurt dışında bulunan hizmet sağlayıcılara aktarılması söz konusu olabilir.
Bu tür aktarımlar yürürlükteki kişisel veri koruma mevzuatına uygun şekilde gerçekleştirilir.
14. Üçüncü taraf bağlantıları
Five Star içerisinde Instagram, Apple veya başka üçüncü taraf platformlara yönlendiren bağlantılar bulunabilir.
Bu platformların gizlilik uygulamalarından Five Star sorumlu değildir.
Üçüncü taraf bir hizmeti kullandığında ilgili hizmetin kendi gizlilik politikası geçerli olur.
15. Bildirimler
Five Star, uygulamanın işleyişiyle ilgili bildirimler gönderebilir.
Örneğin:
• yeni eşleşme dönemi,
• My Date gelişmeleri,
• mesajlar,
• randevu hatırlatmaları,
• üyelik veya hesapla ilgili önemli bilgiler.
Pazarlama veya tanıtım amaçlı iletişimlerin hukuken ayrıca onay gerektirdiği durumlarda gerekli onay ayrıca alınır.
16. Gizlilik tercihlerin ve hakların
Kişisel bilgilerinle ilgili:
• hangi bilgilerin işlendiğini öğrenmek,
• yanlış bilgileri düzeltmek,
• verilerine erişim talep etmek,
• uygun koşullarda verilerinin silinmesini istemek
için bizimle iletişime geçebilirsin.
KVKK kapsamındaki ayrıntılı hakların KVKK Aydınlatma Metni içerisinde açıklanmıştır.
17. Gizlilik Politikasındaki değişiklikler
Five Star geliştikçe bu Gizlilik Politikası zaman zaman güncellenebilir.
Önemli değişikliklerde kullanıcıları uygun yöntemlerle bilgilendirebiliriz.
Politikanın güncel sürümüne uygulama içinden ve meetfivestar.app üzerinden erişilebilir.
18. İletişim
Gizlilik ve kişisel verilerle ilgili:
privacy@meetfivestar.app
Teknik destek:
support@meetfivestar.app
Genel iletişim:
hello@meetfivestar.app
Web:
meetfivestar.app
Veri Sorumlusu: [YASAL ŞİRKET / TÜZEL KİŞİ UNVANI]
Yasal adres: [YASAL ADRES]`;
